<template>
  <div class="whiteborder">
    <FirstTitle :titleName="titleName"></FirstTitle>
  </div>
</template>

<script>
import FirstTitle from "@/views/ReportPlatform/components/ReportFirstTitle.vue";

export default {
  name: "Description",
  components: {
    FirstTitle
  },
  data() {
    return {
      titleName: "举报说明"
    };
  }
};
</script>

<style scoped>
</style>
